import { IFieldForm } from "pages/read-documents/model/IFieldForm";

type IFieldFormDeduction = IFieldForm & {
  required?: boolean;
  maxLength?: number;
};

export const fieldsFormDeduction = (): IFieldForm[] => {
  return [
    {
      id: "itemFormDeductionConceptCode",
      name: "conceptCode",
      type: "text",
      label: "Código concepto",
      placeholder: "Ingrese código de concepto",
      testId: "itemFormDeductionConceptCode",
      isEnable: true,
    },
  ];
};

export const fieldsFormCreateDeduction = (): IFieldFormDeduction[] => {
  return [
    {
      id: "itemFormDeductionConceptCodeCreate",
      name: "conceptCode",
      type: "text",
      label: "Código concepto",
      placeholder: "Ingrese código de concepto",
      testId: "itemFormDeductionConceptCodeCreate",
      isEnable: true,
      required: true,
      maxLength: 30,
    },
    {
      id: "itemFormDeductionDescriptionCreate",
      name: "description",
      type: "text",
      label: "Descripción",
      placeholder: "Ingrese descripción",
      testId: "itemFormDeductionDescriptionCreate",
      isEnable: true,
      required: true,
      maxLength: 300,
    },
    {
      id: "itemFormDeductionAccountingAccountCreate",
      name: "accountingAccount",
      type: "text",
      label: "Cuenta contable",
      placeholder: "Ingrese cuenta contable",
      testId: "itemFormDeductionAccountingAccountCreate",
      isEnable: true,
      required: true,
      maxLength: 30,
    },
    {
      id: "itemFormDeductionPercentageCreate",
      name: "percentage",
      type: "text",
      label: "Porcentaje",
      placeholder: "Ingrese porcentaje",
      testId: "itemFormDeductionPercentageCreate",
      isEnable: true,
      required: true,
      maxLength: 10,
    },
    {
      id: "itemFormDeductionOperationIndicatorCreate",
      name: "operatingIndicator",
      type: "text",
      label: "Indicador de operación",
      placeholder: 'Ingrese "+" or "-"',
      testId: "itemFormDeductionOperationIndicatorCreate",
      isEnable: true,
      required: true,
      maxLength: 1,
    },
    {
      id: "itemFormDeductionValidityCreate",
      name: "fiscalYear",
      type: "text",
      label: "Año fiscal",
      placeholder: "Ingrese año fiscal",
      testId: "itemFormDeductionValidityCreate",
      isEnable: true,
      required: true,
      maxLength: 20,
    },
    {
      id: "itemFormDeductionStartDateCreate",
      name: "startDate",
      type: "date",
      label: "Fecha inicio",
      placeholder: "Ingrese fecha inicio",
      testId: "itemFormDeductionStartDateCreate",
      isEnable: true,
      required: true,
    },
    {
      id: "itemFormDeductionEndDateCreate",
      name: "endDate",
      type: "date",
      label: "Fecha fin",
      placeholder: "Ingrese fecha fin",
      testId: "itemFormDeductionEndDateCreate",
      isEnable: true,
      required: true,
    },
    {
      id: "itemFormDeductionBeneficiaryCreate",
      name: "beneficiary",
      type: "text",
      label: "NIT beneficiario",
      placeholder: "Ingrese NIT beneficiario",
      testId: "itemFormDeductionBeneficiaryCreate",
      isEnable: true,
      required: true,
      maxLength: 20,
    },
    {
      id: "itemFormDeductionBeneficiaryNameCreate",
      name: "beneficiaryName",
      type: "text",
      label: "Razón social beneficiario",
      placeholder: "Ingrese razón social beneficiario",
      testId: "itemFormDeductionBeneficiaryNameCreate",
      isEnable: true,
      required: true,
      maxLength: 300,
    },
  ];
};
